export const environment = {
  production: true,
  /* apiUrl: "http://160.40.53.126/eurodiet" */
  /*  apiUrl: "http://160.40.53.126/evivios_test" */
  /* apiUrl: "https://mental.eviviosmed.com/evivios_test" */
  apiUrl: "https://mental.eviviosmed.com/api"
  /* apiUrl: "https://mental.eviviosmed.com/dev/api" */
};